var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomatedTrafficFineNotificationVehiclesSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 9.33333C18.6667 14.488 14.488 18.6667 9.33333 18.6667C4.17868 18.6667 0 14.488 0 9.33333C0 4.17868 4.17868 0 9.33333 0C14.488 0 18.6667 4.17868 18.6667 9.33333Z",
    fill: "#EE0033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.095 6.50503C13.3683 6.77839 13.3683 7.22161 13.095 7.49498L8.42831 12.1616C8.15494 12.435 7.71173 12.435 7.43836 12.1616L5.57169 10.295C5.29833 10.0216 5.29833 9.57839 5.57169 9.30503C5.84506 9.03166 6.28827 9.03166 6.56164 9.30503L7.93333 10.6767L10.0192 8.59087L12.105 6.50503C12.3784 6.23166 12.8216 6.23166 13.095 6.50503Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedTrafficFineNotificationVehiclesSelected);
export default __webpack_public_path__ + "static/media/AutomatedTrafficFineNotificationVehiclesSelected.2d1764a03ac7377e6243b7df9f7ea6a6.svg";
export { ForwardRef as ReactComponent };